import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Подайте заявку\nна консультацию',
  description: 'С вами свяжется менеджер в течение часа в рабочий день',
} satisfies TMessages
